module.exports = __webpack_public_path__ + "img/VIC-After.bc7f35d7.png";